import { render, staticRenderFns } from "./FixedBox.vue?vue&type=template&id=771ccf6d&scoped=true&"
import script from "./FixedBox.vue?vue&type=script&lang=js&"
export * from "./FixedBox.vue?vue&type=script&lang=js&"
import style0 from "./FixedBox.vue?vue&type=style&index=0&id=771ccf6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771ccf6d",
  null
  
)

export default component.exports